"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuBrands = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const AccordionMenuItem_1 = require("./AccordionMenuItem");
const BrandsIcon_1 = require("../icons/BrandsIcon");
const MenuBrands = ({ businessUnit, brands, highlightItem, idle, loading, onClickItem, }) => ((0, jsx_runtime_1.jsx)(AccordionMenuItem_1.AccordionMenuItem, { id: "brands", title: "Marcas", list: brands, loading: loading || idle, onClickItem: onClickItem, Icon: (0, jsx_runtime_1.jsx)(BrandsIcon_1.BrandsIcon, {}), businessUnit: businessUnit, highlightItem: highlightItem }));
exports.MenuBrands = MenuBrands;
